// src/plugins/vuetify.js
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: localStorage.getItem('darkMode') === 'true' ? 'dark' : 'light',
    themes: {
      light: {
        colors: {
          background: '#f5f5f5',
          surface: '#ffffff',
          primary: '#ff8c54',
          secondary: '#180c24',
        },
      },
      dark: {
        colors: {
          background: '#121212',
          surface: '#1e1e1e',
          primary: '#ff8c54',
          secondary: '#ffffff',
        },
      },
    },
  },
});
